



























































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import userprofile from '@/store/modules/userprofile';
import users from '@/store/modules/users';

@Component({
  components: {},
})
export default class TermsAndCondition extends Vue {
  get needUpdate() {
    return this.$store.getters.userLoggedIn && !this.$store.getters.currentUser.tnc_accepted;
  }

  private async updateTerms() {
    const userData: any = {
      id: this.$store.getters.currentUser.id,
      tnc_accepted: true,
    };
    await userprofile.updateSelfProfile(userData).then((result1) => {
      this.$swal('Success!', 'Your details have been updated', 'success').then((result2: any) => {
        users.refresh().then((res: any) => {
          this.$router.push({ path: '/' });
        });
      });
    });
  }
}
